import { WATERMARK_MAX_OUTPUT_WIDTH } from '../constants'

const downsizeWatermark = (source: File | string): Promise<string> =>
    new Promise((resolve, reject) => {
        const img = document.createElement('img')
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        img.onload = () => {
            const aspectRatio = img.naturalWidth / img.naturalHeight
            canvas.width = Math.min(img.naturalWidth, WATERMARK_MAX_OUTPUT_WIDTH)
            canvas.height = canvas.width / aspectRatio
            context?.drawImage(img, 0, 0, canvas.width, canvas.height)
            resolve(canvas.toDataURL('image/png', 1))
            if (typeof source !== 'string') {
                URL.revokeObjectURL(img.src)
            }
        }
        img.onerror = reject
        img.crossOrigin = 'anonymous'
        img.src = typeof source === 'string' ? source : URL.createObjectURL(source)
    })

export default downsizeWatermark
